// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BuyConfirmButton_wrapper__SrlV6"};